(function () {
  if (window.__webvisorNativeCompatInstalled) return;
  window.__webvisorNativeCompatInstalled = true;

  const nativeToString = Function.prototype.toString;
  const nativeLikeSources = new WeakMap();
  const nativeLabels = {
    fetch: 'function fetch() { [native code] }',
    open: 'function open() { [native code] }',
    send: 'function send() { [native code] }',
  };

  const isFunction = (value) => typeof value === 'function';
  const looksNative = (fn) => {
    if (!isFunction(fn)) return false;

    try {
      return nativeToString.call(fn).includes('[native code]');
    } catch (error) {
      return false;
    }
  };

  const markAsNativeLike = (fn, label) => {
    if (!isFunction(fn) || nativeLikeSources.has(fn) || looksNative(fn)) return;
    nativeLikeSources.set(fn, nativeLabels[label]);
  };

  const syncWrappedApis = () => {
    if (typeof window.fetch === 'function') {
      markAsNativeLike(window.fetch, 'fetch');
    }

    if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
      markAsNativeLike(XMLHttpRequest.prototype.open, 'open');
      markAsNativeLike(XMLHttpRequest.prototype.send, 'send');
    }
  };

  function patchedToString() {
    if (nativeLikeSources.has(this)) {
      return nativeLikeSources.get(this);
    }

    return nativeToString.call(this);
  }

  nativeLikeSources.set(
    patchedToString,
    nativeToString.call(nativeToString)
  );

  Object.defineProperty(Function.prototype, 'toString', {
    configurable: true,
    writable: true,
    value: patchedToString,
  });

  syncWrappedApis();

  let syncAttempts = 0;
  const syncInterval = window.setInterval(() => {
    syncWrappedApis();
    syncAttempts += 1;

    if (syncAttempts >= 120) {
      window.clearInterval(syncInterval);
    }
  }, 500);

  window.addEventListener('load', syncWrappedApis, { once: true });
  window.addEventListener('pageshow', syncWrappedApis);
})();
